export const form = `
<div class="dropdown-component d-flex flex-column align-items-end">
<button
    class="dropdown-component__btn btn"
    ref="header"
>
    <span class="dropdown-component__text">
        {{ctx.t(ctx.component.buttonName, { _userInput: true }) || "Button"}}
    </span>
</button>
{% if (ctx.collapsed || ctx.builder) { %}
<div class="dropdown-component__body" ref="{{ctx.nestedKey}}" id="{{ctx.instance.id}}-{{ctx.component.key}}">
    {{ctx.children}}
</div>
{% } %}
</div>`;
